import { Link } from "wouter";
import { FiCompass } from "react-icons/fi";

import { useI18n } from "@/hooks/use-i18n";
import { useLocalizedUrl } from "@/hooks/use-localized-url";

import { DesktopNav } from "./header/DesktopNav";
import { LanguageSwitcher } from "./header/LanguageSwitcher";
import { UserMenu } from "./header/UserMenu";
import { MobileMenu } from "./header/MobileMenu";

// Barra rossa alta 74px (design system): logo + wordmark Montserrat, navigazione al centro,
// lingua / accesso / menu mobile a destra. Niente bordo né ombra: basta il colore.
export default function Header() {
  const { t } = useI18n();
  const getLocalizedUrl = useLocalizedUrl();

  return (
    <header className="sticky top-0 z-[9999] bg-primary">
      <div className="mx-auto max-w-screen-xl px-4 md:px-6">
        <div className="flex h-[74px] items-center justify-between gap-6">
          {/* Logo */}
          <Link href={getLocalizedUrl("/")}>
            <div className="flex cursor-pointer items-center">
              <div className="mr-3 flex h-12 w-12 items-center justify-center overflow-hidden rounded-md">
                <picture>
                  <source srcSet="/img/logo_ts_dark_mode_optimized.webp" type="image/webp" />
                  <img
                    src="/img/logo_ts_dark_mode_optimized.png"
                    srcSet="/img/logo_ts_dark_mode_optimized.png 1x, /img/logo_ts_dark_mode_optimized_2x.png 2x"
                    alt="Trieste Storica Logo"
                    width="48"
                    height="48"
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                  />
                </picture>
              </div>
              <div className="mr-2 flex flex-col" style={{ lineHeight: "0.35" }}>
                <span
                  className="font-normal text-white"
                  style={{
                    fontSize: "1.25rem",
                    lineHeight: 1.6,
                    marginBottom: "-15px",
                    fontFamily: "'Montserrat', sans-serif",
                    letterSpacing: "0.05em",
                  }}
                >
                  Trieste
                </span>
                <span
                  className="font-normal text-white"
                  style={{
                    fontSize: "1.25rem",
                    lineHeight: 1.6,
                    fontFamily: "'Montserrat', sans-serif",
                    letterSpacing: "0.05em",
                  }}
                >
                  Storica
                </span>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <DesktopNav />

          {/* Right side controls */}
          <div className="flex items-center gap-2">
            {/* Esplora su mappa (compass) — solo mobile, ChakraHeader:485-496 */}
            <Link
              href={getLocalizedUrl("/map/explore")}
              aria-label={t("nav.exploreTrieste")}
              className="flex h-11 w-11 items-center justify-center rounded-lg text-white/90 transition-colors hover:bg-white/10 hover:text-white md:hidden"
            >
              <FiCompass size={20} />
            </Link>
            <LanguageSwitcher />
            <UserMenu />
            <MobileMenu />
          </div>
        </div>
      </div>
    </header>
  );
}
